export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()
  const websocket = useWebSocket()

  const canConnect = computed(() => authStore.isAuthenticated && authStore.hasSessionID && !!authStore.activeLicence)

  watch(
    canConnect,
    (can) => {
      if (can) {
        websocket.connect()
      } else {
        websocket.disconnect()
      }
    },
    { immediate: true }
  )

  watch(
    () => authStore.activeLicence?.id,
    (newId, oldId) => {
      if (newId && oldId && newId !== oldId && canConnect.value) {
        websocket.reconnect()
      }
    }
  )

  if (import.meta.client) {
    window.addEventListener('beforeunload', () => {
      websocket.disconnect()
    })
  }
})
